/** @flow */

import type UIView from "UIView";
import RCTViewManager from "RCTViewManager";

class RCTSafeAreaViewManager extends RCTViewManager {
  static moduleName = "RCTSafeAreaViewManager";
}

export default RCTSafeAreaViewManager;
